import React, { useState, useEffect } from "react";

import Autocomplete from "../ui/Autocomplete";
import NuxeoClient from "../../clients/NuxeoClient";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import InputLabel from "@material-ui/core/InputLabel";

import { useI18n } from "../../I18nProvider";

export default function Property(props) {
  const appText = useI18n();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (props.contractID) {
      setIsLoading(true);
      _loadProperty();
    }
  }, [props.contractID]);

  async function _loadProperty() {
    await NuxeoClient.instance()
      .fetchProperty(props.contractID)
      .then((response) => {
        props.handleChange("fetchedProperty", response);
        setIsLoading(false);
      });
  }

  const handleChange = (property) => {
    props.handleChange("property", property.label);
    props.handleChange("propertyID", property.id);
  };

  return (
    // <Tooltip arrow title="Please select the property">
    <Tooltip arrow title={appText.T117}>
      <Grid item={true} xs={12}>
        <div className="property">
          <InputLabel className="field-label field-dropdown" required>
            {appText.T54}
          </InputLabel>
          <Autocomplete
            type={"single"}
            handleChange={handleChange}
            data={props.fetchedData}
            dataType={"property"}
            mapVariable={"label"}
            setFilterData={() => null}
            value={props.value}
            isLoading={isLoading}
          />
        </div>
      </Grid>
    </Tooltip>
  );
}
